<template>
    <section class="padding-vertical-content">
        <ContentOrLoading :style="eventos?.length === 0 ? 'padding-bottom: 100px' : ''">
            <div class="container" v-if="eventos?.length > 0">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-10">
                        <ul class="grid">
                            <EventoImagen v-for="event in eventos" :productos="productos" :event="event" :key="event.id"/>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="text-center" v-else>
                <h1>En estos momentos no hay eventos a la venta</h1>
            </div>
        </ContentOrLoading>
    </section>
</template>

<script>
import EventoImagen from "./EventoImagen";

export default {
    props: {
        eventos: {
            required: true,
            type: Array
        },
        productos: {
            required: false,
            default:false,
            type: Boolean
        }
    },
    components: {
        EventoImagen
    }
}
</script>
<style scoped>
@media (min-width: 992px) {
    ul.grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        margin: 0 -10px;
    }
}

</style>